import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=fb714f0c&scoped=true"
import script from "./reports.vue?vue&type=script&lang=js"
export * from "./reports.vue?vue&type=script&lang=js"
import style0 from "./reports.vue?vue&type=style&index=0&id=fb714f0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb714f0c",
  null
  
)

export default component.exports